<template>
  <div>
    <div class="row" v-if="canAccess">
      <div class="col-xl-3 col-md-6">
        <div class="card card-stats card-raised">
          <div class="card-body" v-if="this.wallet">
            <div class="row">
              <div class="col-md-12">
                <div class="statistics">
                  <div class="info">
                    <div
                      class="stats-title"
                      style="font-size: 1.5em; font-weight: 500"
                    >
                      จำนวนเงินคงเหลือ
                      <a-button
                        class="card-title"
                        shape="round"
                        @click="showModal(0)"
                      >
                        เติมเงิน
                      </a-button>
                      <!-- <i class="now-ui-icons business_money-coins"></i> -->
                    </div>
                    <h3 class="info-title">
                      <animated-number
                        :value="wallet.balance ?? 0"
                      ></animated-number>
                      <small> บาท</small>
                    </h3>

                    <!-- <h6 class="stats-title">จำนวนเงินคงเหลือ</h6> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <div class="card card-stats card-raised">
          <div class="card-body" v-if="this.wallet">
            <div class="row">
              <div class="col-md-12">
                <div class="statistics">
                  <div class="info">
                    <div
                      class="stats-title"
                      style="font-size: 1.5em; font-weight: 500"
                    >
                      จำนวนเงินที่รออนุมัติ
                    </div>
                    <h3 class="info-title">
                      <animated-number
                        :value="wallet.waitting ?? 0"
                      ></animated-number>
                      <small> บาท</small>
                    </h3>
                    <!-- <h6 class="stats-title">จำนวนเงินที่รออนุมัติ</h6> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <div class="card card-stats card-raised">
          <div class="card-body" v-if="this.wallet">
            <div class="row">
              <div class="col-md-12">
                <div class="statistics">
                  <div class="info">
                    <div
                      class="stats-title"
                      style="font-size: 1.5em; font-weight: 500"
                    >
                      เติมเดือนนี้
                    </div>
                    <h3 class="info-title">
                      <animated-number
                        :value="wallet.thismonth ?? 0"
                      ></animated-number>
                      <small> บาท</small>
                    </h3>
                    <!-- <h6 class="stats-title">จำนวนเงินที่รออนุมัติ</h6> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header">
                <h4 class="card-title">ประวัติการใช้งาน</h4>
              </div>
            </div>
            <div class="col-4">
              <div class="card-header text-right">
                <a-button
                  class="card-title"
                  shape="round"
                >
                  Export
                </a-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <a-table
                :columns="columns"
                :data-source="transactions"
                :loading="historyLoaded"
                :scroll="{ x: 1200 }"
              >
                <template #transDate="{ record }">
                  {{ getDate(record.createdDate) }}
                </template>
                <template #amount="{ record }">
                  {{ getCurrency(record.amount) }}
                </template>
                <template #slipImage="{ record }">
                  <a-image
                    v-if="record.slipImage"
                    :src="record.slipImage"
                    height="50px"
                    width="50px"
                  />
                </template>
                <template #status="{ record }">
                  <a-tag
                    :color="
                      record.statusId === 'approve'
                        ? 'success'
                        : record.statusId === 'reject'
                        ? 'warning'
                        : record.statusId === 'cancel'
                        ? 'error'
                        : 'processing'
                    "
                    >{{ record.status }}</a-tag
                  >
                </template>
                <template #action="{ record }">
                  <a
                    href="#"
                    @click="showModal(record.id)"
                    v-if="record.statusId === 'waiting_approve'"
                    >แก้ไข</a
                  >
                  <a-divider
                    type="vertical"
                    v-if="record.statusId === 'waiting_approve'"
                  />
                  <a
                    href="#"
                    @click="cancel(record.id)"
                    v-if="record.statusId === 'waiting_approve'"
                    >ยกเลิก</a
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess === false">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a-result
              status="403"
              title="403"
              sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
            >
              <template #extra>
                <a-button type="primary" @click="goToHome"
                  >กลับหน้าหลัก</a-button
                >
              </template>
            </a-result>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      destroyOnClose="true"
      v-model:visible="visible"
      title="เติมเงินเข้า Wallet"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
    >
      <Form
        method="#"
        action="#"
        v-on:submit="onSaveWallet"
        :validation-schema="schema"
        ref="myForm"
      >
        <div>
          <a-alert
            :message="`คุณสามารถเติมได้อีก ${getCurrency(
              wallet.maxAmount - wallet.balance ?? 0
            )} บาท และต้องเติมขั้นต่ำ ${getCurrency(wallet.minTopup ?? 0)} บาท`"
            type="info"
            showIcon
          >
          </a-alert>
        </div>
        <br />
        <label>จำนวนเงิน</label>
        <a-input-number
          size="large"
          :min="wallet.minTopup ?? 0"
          :max="wallet.maxAmount - wallet.balance ?? 0"
          v-model:value="walletModel.amount"
          style="width: 100%; margin-bottom: 10px"
          placeholder="Enter amount"
        />
        <br />
        <div>
          <a-divider
            >ยอดเงินหลังเติม:
            {{ getCurrency((wallet.balance ?? 0) + walletModel.amount ?? 0) }}
            บาท</a-divider
          >
        </div>
        <p>แนบหลักฐานการชำระเงิน</p>
        <a-upload
          v-model:file-list="fileList"
          :openFileDialogOnClick="fileList.length < 1"
          name="file"
          :multiple="false"
          accept="image/*"
          :action="url + '/wallet/uploadslip'"
          :headers="headers"
          @change="handleChange"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            Click to Upload
          </a-button>
        </a-upload>
        <br />
        <a-typography-text type="secondary"
          >หลังจากทำการเติมเงินแล้วกรุณาติดต่อ Admin ทาง Line OA
          เพื่ออนุมัติรายการ</a-typography-text
        >

        <button ref="submit" style="display: none">Submit</button>
      </Form>
    </a-modal>
  </div>
</template>

<script>
let url = "http://18.142.153.80:9999/romons.payment/api";
import { message, Modal } from "ant-design-vue";
import {
  ExclamationCircleOutlined,
  SmileOutlined,
} from "@ant-design/icons-vue";
import { AnimatedNumber, VeeInput } from "@/components";
import { ref, createVNode } from "vue";
import * as Yup from "yup";
import moment from "moment";
import { Form } from "vee-validate";
import * as paymentservice from "../../services/payment";
import * as configuration from "../../middleware/configuration";
import Swal from "sweetalert2";

const columns = [
  {
    title: "วันที่",
    slots: { customRender: "transDate" },
    key: "createdDate",
    width: "200px",
  },
  {
    title: "หมายเลขรายการ",
    dataIndex: "no",
    key: "no",
    ellipsis: true,
  },
  {
    title: "รายการ",
    dataIndex: "actionType",
    key: "actionType",
    width: "80px",
  },
  {
    title: "ประเภท",
    dataIndex: "transType",
    key: "transType",
    width: "80px",
  },
  {
    title: "จำนวนเงิน",
    slots: { customRender: "amount" },
    key: "amount",
    align: "right",
    width: "120px",
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    width: "80px",
  },
  {
    title: "หลักฐานการชำระเงิน",
    slots: { customRender: "slipImage" },
    key: "slipImage",
    align: "center",
    width: "180px",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "status",
    align: "center",
    width: "80px",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 120,
  },
];
export default {
  components: {
    AnimatedNumber,
    VeeInput,
    Form,
    SmileOutlined,
  },
  methods: {
    async getWallet() {
      try {
        let res = await paymentservice.getWalletByUid(this.uid);
        if (res.data) {
          let res_trans = await paymentservice.getWalletTransactionsByid(
            res.data.id
          );
          this.transactions = res_trans.data;

          let waitting = res_trans.data.filter(
            (x) => x.statusId === "waiting_approve"
          );
          let thismonth = res_trans.data.filter(
            (x) =>
              x.statusId === "approve" &&
              new Date(x.createdDate).getMonth() === new Date().getMonth()
          );
          this.wallet = res.data;
          if (waitting) {
            this.wallet.waitting = waitting
              .map((x) => x.amount)
              .reduce((a, b) => a + b, 0);
          } else {
            this.wallet.waitting = 0;
          }
          if (thismonth) {
            this.wallet.thismonth = thismonth
              .map((x) => x.amount)
              .reduce((a, b) => a + b, 0);
          } else {
            this.wallet.thismonth = 0;
          }
        }
      } catch (error) {
        message.error(`ไม่สามารถดึงข้อมูลได้ กรุณาลองอีกครั้ง`);
      }
    },
    showModal(id) {
      let wallet = this.transactions.find((x) => x.id === id);
      this.walletModel = {
        id: id,
        walletId: wallet?.walletId ?? 0,
        amount: wallet?.amount ?? this.wallet?.minTopup,
        picture: "",
      };
      this.visible = true;
    },
    handleOk(e) {
      this.$refs.submit.click();
    },
    async onSaveWallet(values) {
      let max = this.wallet.maxAmount - this.wallet.balance;
      let min = this.wallet.minTopup;
      if (this.walletModel.amount > max) {
        message.error(`คุณสามารถเติมเงินได้สุงสุด ${max} บาท`);
        return;
      }

      if (min > this.walletModel.amount) {
        message.error(`คุณสามารถเติมเงินได้ต่ำสุด ${min} บาท`);
        return;
      }

      var image = this.fileList.shift();
      let data = {
        id: this.walletModel.id,
        walletId: this.walletModel.walletId,
        uid: this.uid,
        actionType: "เติมเงิน",
        transType: "ฝาก",
        amount: this.walletModel.amount,
        unit: "บาท",
        status: "waiting_approve",
        slipImage:
          image !== undefined ? image.response.url : this.walletModel.picture,
      };
      try {
        let res = await paymentservice.saveWalletTransaction(data);
        message.success(`บันทึกข้อมูลสำเร็จ`);
        this.visible = false;
        this.getWallet();
      } catch (error) {
        console.log(error);
        this.confirmLoading = false;
      }
    },
    onAmountChange(e) {
      debugger;
    },
    async cancel(id) {
      let wallet = this.transactions.find((x) => x.id === id);

      Modal.confirm({
        title: "ยกเลิกรายการ",
        icon: createVNode(ExclamationCircleOutlined),
        content: "คุณต้องการยกเลิกรายการ " + wallet.no + " หรือไม่?",
        okText: "ยกเลิก",
        cancelText: "ปิด",
        onOk: async () => {
          let data = {
            id: id,
            uid: this.uid,
            status: "cancel",
          };
          try {
            let res = await paymentservice.updateWalletTransactionStatus(data);
            message.success(`บันทึกข้อมูลสำเร็จ`);
            this.getWallet();
          } catch (error) {
            console.log(error);
          }
        },
      });
    },
    getCurrency(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY HH:mm:ss");
      return "";
    },
  },
  data() {
    return {
      code: "",
      columns: columns,
      confirmLoading: false,
      uid: "",
      data: [],
      historyLoaded: false,
      canAccess: true,
      visible: false,
      url: url,
      walletModel: {},
      wallet: null,
      transactions: [],
    };
  },
  setup() {
    const schema = Yup.object().shape({
      amount: Yup.number()
        .required()
        .label("The amount")
        .min(0)
        .transform((_, val) => {
          return val === "" || isNaN(val) ? "0" : val * 1;
        }),
    });
    const handleChange = (info) => {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    };
    const fileList = ref([]);
    return {
      schema,
      fileList,
      handleChange,
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    await this.getWallet();
  },
};
</script>

<style>
</style>